import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, formatPrice } from "@/lib/api";
import { toast } from "sonner";

const FEE_COLORS = { Pending: "bg-amber-100 text-amber-700", Paid: "bg-emerald-100 text-emerald-700", "Not Applicable": "bg-slate-100 text-slate-500" };

export default function AdminFees() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/admin/fees").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const updateFee = async (id, fee, patch) => {
    const next = { ...fee, ...patch };
    try { await api.patch(`/admin/machines/${id}/fee`, next); toast.success("Fee updated"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-extrabold text-slate-900">Listing Fees</h1>
      <p className="mt-1 text-slate-500">Track offline listing fee collection per machine.</p>
      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div> : (
        <div className="mt-5 overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead className="border-b border-slate-200 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-400">
              <tr>
                <th className="px-4 py-3">Machine</th>
                <th className="px-4 py-3">Amount</th>
                <th className="px-4 py-3">Fee Status</th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id} data-testid={`fee-row-${r.machine_code}`}>
                  <td className="px-4 py-3">
                    <p className="font-semibold text-slate-900">{r.machine_code}</p>
                    <p className="text-xs text-slate-500">{r.machine_name}</p>
                    <p className="text-xs text-slate-400">{r.seller_name}</p>
                  </td>
                  <td className="px-4 py-3 font-semibold text-slate-900">{r.fee?.amount ? formatPrice(r.fee.amount, "Fixed") : "—"}</td>
                  <td className="px-4 py-3">
                    <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${FEE_COLORS[r.fee?.status] || FEE_COLORS.Pending}`}>{r.fee?.status || "Pending"}</span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex gap-1">
                      {r.fee?.status !== "Paid" && <button onClick={() => updateFee(r.id, r.fee || {}, { status: "Paid", payment_date: new Date().toISOString().slice(0, 10) })} className="rounded-md bg-emerald-600 px-2.5 py-1 text-xs font-bold text-white">Mark Paid</button>}
                      {r.fee?.status !== "Pending" && <button onClick={() => updateFee(r.id, r.fee || {}, { status: "Pending" })} className="rounded-md border border-slate-300 px-2.5 py-1 text-xs font-bold text-slate-600">Pending</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
